export default __webpack_public_path__ + "static/media/954.db11c265.png";